import { fetch } from '../../lib/fetch';
import { RateLimitError } from './ratelimit-error';
import { createHeaders, getStatusBehavior, parseRetryAfter, resolveHttpConfig, } from './shared-dispatcher';
export default function (config, httpConfig) {
    function dispatch(url, body, retryCountHeader) {
        var headers = createHeaders(config === null || config === void 0 ? void 0 : config.headers);
        var writeKey = body === null || body === void 0 ? void 0 : body.writeKey;
        if (writeKey) {
            var authtoken = btoa(writeKey + ':');
            headers['Authorization'] = "Basic ".concat(authtoken);
        }
        if (retryCountHeader) {
            headers['X-Retry-Count'] = String(retryCountHeader);
        }
        return fetch(url, {
            credentials: config === null || config === void 0 ? void 0 : config.credentials,
            keepalive: config === null || config === void 0 ? void 0 : config.keepalive,
            headers: headers,
            method: 'post',
            body: JSON.stringify(body),
            // @ts-ignore - not in the ts lib yet
            priority: config === null || config === void 0 ? void 0 : config.priority,
        }).then(function (res) {
            var status = res.status;
            // Treat <400 as success (2xx/3xx)
            if (status < 400) {
                return;
            }
            // Resolve config once (uses caller-supplied or built-in defaults).
            var resolved = httpConfig !== null && httpConfig !== void 0 ? httpConfig : resolveHttpConfig();
            // Determine retry/drop behavior from config (checks statusCodeOverrides first).
            var behavior = getStatusBehavior(status, resolved.backoffConfig);
            // Honor Retry-After for rate limiting, unless the status is explicitly
            // overridden to 'drop' via statusCodeOverrides.
            if (behavior !== 'drop') {
                var retryAfter = parseRetryAfter(res, resolved.rateLimitConfig);
                if (retryAfter) {
                    throw new RateLimitError("Rate limit exceeded: ".concat(status), retryAfter.retryAfterMs, retryAfter.fromHeader);
                }
            }
            // Retry via backoff when the status is retryable.
            if (behavior === 'retry') {
                throw new Error("Retryable error: ".concat(status));
            }
            var err = new Error("Non-retryable error: ".concat(status));
            err.name = 'NonRetryableError';
            throw err;
        });
    }
    return {
        dispatch: dispatch,
    };
}
//# sourceMappingURL=fetch-dispatcher.js.map